import Navbar from "../../components/navbar/Navbar";
import "./About.css";
import skillsInformation from "./skills";
import GamesVideo from "../../components/games_video/Games_Video";
import MenuBar from "../../components/menuBar/MenuBar";
import Skills from "../../components/skills/Skills";
import Games from "../../components/games/Games";
import Socials from "../../components/socials/Socials";
import Footer from "../../components/footer/Footer";
import MyPhoto from "./assets/myPhoto.png";
import HeaderElement from "./assets/headerElement.png";
import headerElement2 from "./assets/headerElement2.png";
import describeElement from "./assets/describeElement.png";

function AddIcon({ icon }) {
  return <img src={icon} alt={icon} className="caption-icon" />;
}

function AboutPage() {
  const skills = skillsInformation;

  return (
    <div className="about-page">
      <Navbar />
      <MenuBar />
      <div className="header">
        <div className="element1">
          <AddIcon icon={HeaderElement} />
        </div>
        <div className="entry">
          <h1>
            Hi There,
            <br />
            I'm <span className="blue">Przemek Murawski</span>,
            <br />
            <span className="rank">
              Full Stack Web Game & Blockchain Developer
            </span>
          </h1>
        </div>
        <div className="element2">
          <AddIcon icon={headerElement2} />
        </div>
        <div className="photo">
          <AddIcon icon={MyPhoto} />
        </div>
      </div>

      <p className="title" id="career">
        Career
      </p>
      <div className="descriptionPage">
        <div className="description">
          <h2>
            <span className="blue"> TOP</span> developer of{" "}
            <span className="red">Phaser 3</span> and{" "}
            <span className="red">Pixi.js</span> games. I have{" "}
            <span className="blue"> 3 years of experience</span> in game
            development as a freelancer. During my tenure, I have expertise in
            working with both{" "}
            <span className="blue">Centralized Databases (CDB)</span> and{" "}
            <span className="blue">Decentralized Databases (DDB)</span>
            .
            <br />
            <br />I developed my skills by creating projects on online platforms
            for freelancers and working on orders from people from my
            environment. I mainly created{" "}
            <span className="blue">Open World</span>,{" "}
            <span className="blue">Real-time Multiplayer</span>,{" "}
            <span className="blue">Educational</span> and{" "}
            <span className="blue">Gambling</span> games.
            <br />
            <br />
            My acquired knowledge allows me to have{" "}
            <span className="blue"> in-depth knowledge </span> in games
            operation, optimization and keeps the code structure readable for
            future fixes which makes me a person who who will complete your jobs
            correctly the first time.
            <br />
            <br />
            Additionally, I have a background as a{" "}
            <span className="blue">graphic designer</span>, enhancing my skill
            set. I incorporate visually appealing elements into my game designs
            for immersive user experiences.
            <br />
            <br />
            As a child I played multiplayer games and was always curious about
            how they work. I was wondering why some people are good at cheating
            in games and how they both do it. When I delved into this topic, I
            wanted to create my own game and that's how my career began.
            <br />
            <br />I think <span className="blue">Web 3.0 </span>is the future
            that will take over the internet, so I'm training my skills in{" "}
            <span className="blue">Blockchain technology</span> .
            <br />I created my own <span className="blue">NFT</span> and simple{" "}
            <span className="blue">NFT game</span>.
          </h2>
        </div>
      </div>
      <div className="skillsPage">
        <div className="skills">
          <h2>
            <br />
            <strong>I’m experienced in:</strong>
            <br />
            <br /> <em>Frontend:</em>
            <br />
            <ul>
              {skills.map((skill, index) => (
                <li key={index}>
                  <i>{skill.name}</i>
                  <br />
                  {index === 6 && (
                    <span className="white">
                      {" "}
                      <br />
                      <em>Backend:</em>
                    </span>
                  )}

                  {index === 10 && (
                    <span className="white">
                      {" "}
                      <br />
                      <em>Blockchain:</em>
                    </span>
                  )}

                  {index === 13 && (
                    <span className="white">
                      {" "}
                      <br />
                      <em>Mobile application development:</em>
                    </span>
                  )}

                  {index === 14 && (
                    <span className="white">
                      {" "}
                      <br />
                      <em>Tools:</em>
                    </span>
                  )}
                </li>
              ))}
            </ul>
            <br />
            {skills.map((skill, index) => (
              <AddIcon key={index} icon={skill.icon} />
            ))}
            <br />I can also create a game for the{" "}
            <span className="blue">Android</span> platform using Apache Cordova.
          </h2>
        </div>
        <div className="describeElement">
          <AddIcon key="describe" icon={describeElement} />
        </div>
      </div>
      <Skills />
      <Games />
      <GamesVideo />
      <Socials />
      <Footer />
    </div>
  );
}

export default AboutPage;
